export default "__VITE_ASSET__By6jy$lA__"